export const STATUSES = [
  "open",
  "assigned",
  "accepted",
  "on_the_way",
  "reached",
  "in_progress",
  "waiting_parts",
  "completed",
  "closed",
  "cancelled",
];

export const STATUS_LABELS = {
  open: "Open",
  assigned: "Assigned",
  accepted: "Accepted",
  on_the_way: "On the Way",
  reached: "Reached",
  in_progress: "In Progress",
  waiting_parts: "Waiting Parts",
  completed: "Completed",
  closed: "Closed",
  cancelled: "Cancelled",
};

export const PRIORITIES = ["low", "medium", "high", "urgent"];

export const PRIORITY_LABELS = {
  low: "Low",
  medium: "Medium",
  high: "High",
  urgent: "Urgent",
};

export function fmtCurrency(n) {
  const v = Number(n || 0);
  return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(v);
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "2-digit" });
  } catch {
    return iso;
  }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(undefined, { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
}
